export default function initWinnersGalleryFilter() {
    const yearFilter = document.getElementById('winners-year-filter');
    const awardFilter = document.getElementById('winners-award-filter');
    const categoryFilter = document.getElementById('winners-category-filter');
    const orderFilter = document.getElementById('winners-order-filter');
    const resultsContainer = document.getElementById('winners-results');

    if (!yearFilter || !awardFilter || !categoryFilter || !orderFilter || !resultsContainer) {
        return;
    }

    let currentPage = 1;
    let maxPages = 1;
    let isLoading = false;

    function getFilterValues() {
        return {
            year: yearFilter.value,
            award: awardFilter.value,
            category: categoryFilter.value,
            order_by: orderFilter.value
        };
    }

    function filterWinners() {
        if (isLoading) return;

        const filters = getFilterValues();

        // Add loading state
        resultsContainer.classList.add('winners-gallery__results--loading');
        resultsContainer.setAttribute('aria-busy', 'true');
        isLoading = true;

        // Reset to page 1 when filtering
        currentPage = 1;

        // Make AJAX request
        fetch(winnersGalleryFilter.ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'filter_winners_gallery',
                nonce: winnersGalleryFilter.nonce,
                year: filters.year,
                award: filters.award,
                category: filters.category,
                order_by: filters.order_by,
                page: currentPage
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                resultsContainer.innerHTML = data.data.html;
                maxPages = data.data.max_pages;

                // Add load more button if needed
                if (maxPages > currentPage) {
                    addLoadMoreButton();
                }
            } else {
                resultsContainer.innerHTML = '<p class="winners-gallery__error">An error occurred. Please try again.</p>';
            }
        })
        .catch(error => {
            console.error('Error filtering winners:', error);
            resultsContainer.innerHTML = '<p class="winners-gallery__error">An error occurred. Please try again.</p>';
        })
        .finally(() => {
            resultsContainer.classList.remove('winners-gallery__results--loading');
            resultsContainer.setAttribute('aria-busy', 'false');
            isLoading = false;
        });
    }

    function loadMoreWinners() {
        if (isLoading || currentPage >= maxPages) return;

        const loadMoreBtn = document.querySelector('.winners-gallery__load-more');
        if (!loadMoreBtn) return;

        const filters = getFilterValues();

        // Add loading state to button
        loadMoreBtn.classList.add('loading');
        loadMoreBtn.textContent = 'Loading...';
        loadMoreBtn.disabled = true;
        isLoading = true;

        // Increment page
        currentPage++;

        // Make AJAX request
        fetch(winnersGalleryFilter.ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'load_more_winners',
                nonce: winnersGalleryFilter.nonce,
                year: filters.year,
                award: filters.award,
                category: filters.category,
                order_by: filters.order_by,
                page: currentPage
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Find the list container and append new items
                const listContainer = resultsContainer.querySelector('.winners-gallery__list');
                if (listContainer) {
                    // Create temporary container to parse HTML
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data.data.html;

                    // Append each new item to the list (look for .post-item since that's what get_component returns)
                    const newItems = tempDiv.querySelectorAll('.post-item');
                    newItems.forEach(item => {
                        listContainer.appendChild(item);
                    });
                }

                maxPages = data.data.max_pages;

                // Remove or update load more button
                if (currentPage >= maxPages) {
                    loadMoreBtn.remove();
                } else {
                    loadMoreBtn.classList.remove('loading');
                    loadMoreBtn.textContent = 'Load More';
                    loadMoreBtn.disabled = false;
                }
            } else {
                console.error('Error loading more winners');
            }
        })
        .catch(error => {
            console.error('Error loading more winners:', error);
            currentPage--; // Revert page increment on error
        })
        .finally(() => {
            isLoading = false;
        });
    }

    function addLoadMoreButton() {
        const existingWrapper = resultsContainer.querySelector('.winners-gallery__load-more-wrapper');
        if (existingWrapper) {
            existingWrapper.remove();
        }

        const loadMoreWrapper = document.createElement('div');
        loadMoreWrapper.className = 'winners-gallery__load-more-wrapper';

        const loadMoreBtn = document.createElement('button');
        loadMoreBtn.type = 'button';
        loadMoreBtn.className = 'winners-gallery__load-more';
        loadMoreBtn.textContent = 'Load More';

        loadMoreBtn.addEventListener('click', loadMoreWinners);

        loadMoreWrapper.appendChild(loadMoreBtn);
        resultsContainer.appendChild(loadMoreWrapper);
    }

    // Add event listeners to filters
    yearFilter.addEventListener('change', filterWinners);
    awardFilter.addEventListener('change', filterWinners);
    categoryFilter.addEventListener('change', filterWinners);
    orderFilter.addEventListener('change', filterWinners);

    // Initialize load more button if it exists on page load
    const initialLoadMoreBtn = document.querySelector('.winners-gallery__load-more');
    if (initialLoadMoreBtn) {
        // Get initial max pages from the button's data attribute
        const initialMaxPages = parseInt(initialLoadMoreBtn.getAttribute('data-max-pages'));
        if (initialMaxPages) {
            maxPages = initialMaxPages;
        }

        initialLoadMoreBtn.addEventListener('click', loadMoreWinners);
    }
}
